export default {
  "content": "<path d=\"M16 7H3.83l5.6-5.6L8 0 0 8l8 8 1.4-1.4L3.83 9H16V7z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "#FFF",
    "viewBox": "0 0 16 16"
  }
};